import { render, staticRenderFns } from "./PowTourStts.vue?vue&type=template&id=ff38cc68&"
import script from "./PowTourStts.vue?vue&type=script&lang=js&"
export * from "./PowTourStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports